<template>
  <div class="cogs-nav">
    <div class="nav-links">
      <router-link to="/cogs" exact>
        <font-awesome-icon icon="gears" />
        Cost of Goods Sold
      </router-link>
      <router-link to="/cogs/products">
        <font-awesome-icon icon="box" />
        Products & Suppliers
      </router-link>
      <router-link to="/cogs/base-recipes">
        <font-awesome-icon icon="clipboard-list" />
        Base Recipes
      </router-link>
      <router-link to="/cogs/site-menus">
        <font-awesome-icon icon="utensils" />
        Menu Recipes
      </router-link>
    </div>
    <div class="site-select">
      <label for="cogs-site-select">Current Site:</label>
      <select name="cogs-site-select" id="cogs-site-select" @change="handleSelectedSite($event.target.value)">
        <option v-if="!getCogsSelectedSite" disabled selected>Choose a site...</option>
        <option v-for="site in sites" :key="site.site" :value="site.site">
          {{ site.site }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { cogsMixin } from "./cogsMixin";

export default {
  name: "CogsNav",
  mixins: [cogsMixin],
  data() {
    return {};
  },

  methods: {
    handleSelectedSite(site) {
      this.$store.dispatch("updateCogsSelectedSite", site);
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.cogs-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  border-bottom: 1px solid var(--border-colour);
  background-color: var(--primary-colour);
  box-shadow: none;

  .nav-links {
    display: flex;

    a {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.85rem 1.25rem;
      border: 1px solid transparent;
      border-radius: 0.35rem 0.35rem 0 0;
      color: var(--text-colour);
      font-size: 0.95rem;
      font-weight: 500;
      text-decoration: none;
      opacity: 0.55;
      transition: opacity 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
      margin-bottom: -1px;

      &:hover {
        opacity: 1;
      }

      &.router-link-active {
        opacity: 1;
        color: var(--action-colour);
        background-color: var(--primary-colour);
        border-color: var(--border-colour);
        border-bottom-color: var(--primary-colour);
      }
    }
  }

  .site-select {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    label {
      color: var(--text-colour);
      font-size: 0.85rem;
      opacity: 0.7;
      white-space: nowrap;
    }

    select {
      padding: 0.4rem 0.6rem;
      border-radius: 0.35rem;
      border: 1px solid var(--border-colour);
      background-color: var(--secondary-colour);
      color: var(--text-colour);
      font-size: 0.85rem;
    }
  }
}
</style>
